import { useMemo } from 'react';
import { useStore } from '../contexts/StoreContext';
import { useAuth } from '../contexts/AuthContext';
import { EngagementLogger, type EngagementMemoryStore } from '../services/engagement-logger';

export function useEngagementLogger(): EngagementLogger | null {
  const { store } = useStore();
  const { wallet } = useAuth();
  const userId = wallet?.address ?? 'anonymous';

  return useMemo(() => {
    if (!store) return null;
    // MemoryStore from @ownyou/memory-store satisfies EngagementMemoryStore
    return new EngagementLogger(store as EngagementMemoryStore, userId);
  }, [store, userId]);
}
